import { fetchAccountIdentities, fetchIdentitiesById, fetchDetailedIdentity } from './api';
import * as Selectors from './selectors';

export const FETCH_ACCOUNT_IDENTITIES_REQUESTED = 'FETCH_ACCOUNT_IDENTITIES_REQUESTED';
export const FETCH_ACCOUNT_IDENTITIES_SUCCEEDED = 'FETCH_ACCOUNT_IDENTITIES_SUCCEEDED';
export const FETCH_ACCOUNT_IDENTITIES_FAILED = 'FETCH_ACCOUNT_IDENTITIES_FAILED';

export const FETCH_DETAILED_IDENTITY_REQUESTED = 'FETCH_DETAILED_IDENTITY_REQUESTED';
export const FETCH_DETAILED_IDENTITY_SUCCEEDED = 'FETCH_DETAILED_IDENTITY_SUCCEEDED';
export const FETCH_DETAILED_IDENTITY_FAILED = 'FETCH_DETAILED_IDENTITY_FAILED';

export const FETCH_IDENTITIES_REQUESTED = 'FETCH_IDENTITIES_REQUESTED';
export const FETCH_IDENTITIES_SUCCEEDED = 'FETCH_IDENTITIES_SUCCEEDED';
export const FETCH_IDENTITIES_FAILED = 'FETCH_IDENTITIES_FAILED';

const expiresPattern = /&Expires=(\d*)/;
const FIVE_MINUTES = 5 * 60 * 1000;
const isSignedUrlFresh = signedUrl => {
    const expiresMatch = signedUrl && signedUrl.match(expiresPattern);
    const expires = expiresMatch && Number(expiresMatch[1]);
    const expiresDate = expires && new Date(expires * 1000);
    return  expiresDate - new Date() > FIVE_MINUTES;
}

const makeActionCreator = (type, isError) => (payload, meta) => {
    const action = {
        type,
        payload
    };
    if (isError) {
        if (!(payload instanceof Error)) throw new TypeError(`${type} is an error action, but the payload is not an instace of Error: ${payload}`);
        action.isError = true;
    }
    if (meta) action.meta = meta;
    return action;
}

const fetchAccountIdentitiesRequested = makeActionCreator(FETCH_ACCOUNT_IDENTITIES_REQUESTED);
const fetchAccountIdentitiesSucceeded = makeActionCreator(FETCH_ACCOUNT_IDENTITIES_SUCCEEDED);
const fetchAccountIdentitiesFailed = makeActionCreator(FETCH_ACCOUNT_IDENTITIES_FAILED, true);

/**
 * Load all identities associated with the user's account. Identities do not include faces array.
 * Used to populate Facial Recognition settings section
 **/
export const loadAccountIdentities = stage => (dispatch, getState) => {
    const loading = Selectors.loading(getState());
    if (loading) {
        return Promise.resolve();
    }
    dispatch(fetchAccountIdentitiesRequested());
    return fetchAccountIdentities(stage).then(
        data => dispatch(fetchAccountIdentitiesSucceeded(data)),
        err => dispatch(fetchAccountIdentitiesFailed(err))
    );
}

/**
 * Load a detailed identity record with faces
 **/
export const loadDetailedIdentity = (stage, identityId) => (dispatch, getState) => {
    if (!identityId) {
        return Promise.reject(TypeError('loadDetailedIdentity requires identityId'));
    }
    if (Selectors.loadingDetailedIdentity(getState(), identityId)) {
        return Promise.resolve();
    }
    dispatch({
        type: FETCH_DETAILED_IDENTITY_REQUESTED,
        meta: [identityId],
    });
    return fetchDetailedIdentity(stage, identityId).then(
        data => dispatch({
            type: FETCH_DETAILED_IDENTITY_SUCCEEDED,
            payload: data,
            meta: [identityId],
        }),
        err => dispatch({
            type: FETCH_DETAILED_IDENTITY_FAILED,
            payload: err,
            meta: [identityId],
        }),
    );
}

/**
 * For each identityId in identityIds, check if we have a valid and not-expiring-soon Profile
 * Image Url in the store and if not, request it from the kloud.
 * TODO - remove the need for the stage param.  stage could be part of the thunk context
 **/
export const requestProfilesForIdentities = (stage, identityIds) => (dispatch, getState) => {
    if (!identityIds) {
        return Promise.reject(TypeError('requestProfilesForIdentities requires identityIds'));
    }
    const idsRequiringFetch = identityIds.filter(identityId => {
        if (Selectors.loading(getState(), identityId)) return false;
        const identity = Selectors.identity(getState(), identityId);
        return !(identity && identity.profileImageUrl && isSignedUrlFresh(identity.profileImageUrl));
    });
    if (idsRequiringFetch.length === 0) {
        return Promise.resolve();
    }
    dispatch({
        type: FETCH_IDENTITIES_REQUESTED,
        meta: idsRequiringFetch,
    });
    return fetchIdentitiesById(stage, idsRequiringFetch).then(
        data => dispatch({
            type: FETCH_IDENTITIES_SUCCEEDED,
            payload: data,
            meta: idsRequiringFetch,
        }),
        err => dispatch({
            type: FETCH_IDENTITIES_FAILED,
            payload: err,
            meta: idsRequiringFetch,
        }),
    );
}
